import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-navy text-brand-ivory relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={COMPANY.logo} alt="logo" className="h-14 w-14 object-contain bg-white rounded-sm p-1" />
            <div>
              <div className="font-serif text-2xl">Wilshire</div>
              <div className="text-[10px] tracking-[0.35em] text-brand-gold uppercase">Buildcon Co.</div>
            </div>
          </div>
          <p className="text-sm text-brand-ivory/70 leading-relaxed">
            India's trusted name in property solutions. Buy, sell, rent — with transparency and trust.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-brand-gold/40 hover:bg-brand-gold hover:text-brand-navy transition-colors"><Facebook size={16} /></a>
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-brand-gold/40 hover:bg-brand-gold hover:text-brand-navy transition-colors"><Instagram size={16} /></a>
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-brand-gold/40 hover:bg-brand-gold hover:text-brand-navy transition-colors"><Linkedin size={16} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-brand-gold">Quick Links</h4>
          <ul className="space-y-2 text-sm text-brand-ivory/80">
            <li><Link to="/" className="hover:text-brand-gold">Home</Link></li>
            <li><Link to="/properties" className="hover:text-brand-gold">Properties</Link></li>
            <li><Link to="/about" className="hover:text-brand-gold">About</Link></li>
            <li><Link to="/services" className="hover:text-brand-gold">Services</Link></li>
            <li><Link to="/submit-property" className="hover:text-brand-gold">List Property</Link></li>
            <li><Link to="/contact" className="hover:text-brand-gold">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-brand-gold">Categories</h4>
          <ul className="space-y-2 text-sm text-brand-ivory/80">
            <li><Link to="/properties?category=residential" className="hover:text-brand-gold">Residential</Link></li>
            <li><Link to="/properties?category=commercial" className="hover:text-brand-gold">Commercial</Link></li>
            <li><Link to="/properties?category=office" className="hover:text-brand-gold">Office</Link></li>
            <li><Link to="/properties?category=warehouse" className="hover:text-brand-gold">Warehouse</Link></li>
            <li><Link to="/properties?category=villa" className="hover:text-brand-gold">Villas</Link></li>
            <li><Link to="/properties?category=plot" className="hover:text-brand-gold">Plots & Land</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-brand-gold">Get in Touch</h4>
          <div className="space-y-3 text-sm text-brand-ivory/80">
            <div className="flex items-start gap-3"><MapPin size={16} className="text-brand-gold mt-1 flex-shrink-0" /><span>{COMPANY.address}</span></div>
            <div className="flex items-center gap-3"><Phone size={16} className="text-brand-gold flex-shrink-0" /><a href={`tel:${COMPANY.phone}`} className="hover:text-brand-gold">{COMPANY.phone}</a></div>
            <div className="flex items-center gap-3"><Mail size={16} className="text-brand-gold flex-shrink-0" /><a href={`mailto:${COMPANY.email}`} className="hover:text-brand-gold">{COMPANY.email}</a></div>
          </div>
        </div>
      </div>

      <div className="border-t border-brand-gold/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-brand-ivory/60">
          <span>© {new Date().getFullYear()} Wilshire Buildcon Co. All rights reserved.</span>
          <span>Buy • Sell • Rent With Trust</span>
        </div>
      </div>
    </footer>
  );
}
